import { gql } from '@apollo/client'

export const GET_DISPLAY_TYPES = gql`
  query DisplayTypes($input: DisplayTypeInput!) {
    displayTypes(input: $input) {
      count
      results {
        name
        id
      }
    }
  }
`
